import { Nullable } from "@core/domain/types/nullable.type";
import { LoadLayoutStore } from "@core/presentacion/component/feedback/load-layout/load-layout.store";
import { BaseViewModel } from "@core/presentacion/view-model/base/base.viewmodel";
import { CreateEntityApiKey } from "@entity-api-keys/domain/models/create-entity-api-key.model";
import { CreatedEntityApiKey } from "@entity-api-keys/domain/models/entity-api-key.model";
import { CreateEntityApiKeyUseCase } from "@entity-api-keys/domain/usecases/create-entity-api-key.usecase";
import { inject, injectable } from "inversify";
import { makeObservable } from "mobx";

export interface CreateEntityApiKeyFormValuesValidated {
    entityId: number | null;
    name: string;
    scopes: string[];
    isActive: boolean;
}

@injectable()
export class CreateEntityApiKeyPageViewModel extends BaseViewModel {
    constructor(
        @inject(CreateEntityApiKeyUseCase)
        private readonly createUseCase: CreateEntityApiKeyUseCase,
    ) {
        super();
        makeObservable(this);
    }

    async create(
        values: CreateEntityApiKeyFormValuesValidated,
    ): Promise<Nullable<CreatedEntityApiKey>> {
        LoadLayoutStore.start();

        const model = new CreateEntityApiKey(
            values.entityId ?? undefined,
            values.name,
            values.scopes,
            values.isActive,
        );

        const created = await this.createUseCase.execute(model);

        LoadLayoutStore.finish();

        return created;
    }
}
